export const portalConstants = {
    SET_PORTAL_SETTINGS: 'SET_PORTAL_SETTINGS',
    PAGE_UPDATED: 'PAGE_UPDATED',
    PORTAL_LOADING: 'PORTAL_LOADING',
    SHOW_LOGIN_ALERT: 'SHOW_LOGIN_ALERT',
    SHOW_CUSTOM_LOGIN_MODAL: 'SHOW_CUSTOM_LOGIN_MODAL',
    SHOW_CUSTOM_REGISTER_MODAL: 'SHOW_CUSTOM_REGISTER_MODAL',
    SHOW_SIDEBAR: 'SHOW_SIDEBAR',
    SHOW_CONTACT_FOR_GAME_ACCOUNT_ALERT: 'SHOW_CONTACT_FOR_GAME_ACCOUNT_ALERT',
    AFFILIATE_VALIDATED: 'AFFILIATE_VALIDATED',
    GOOGLE_SCRIPT_LOADED: 'GOOGLE_SCRIPT_LOADED',
    GET_CONTACT_LIST: 'GET_CONTACT_LIST',
    RENDER_LOGIN_BAR: 'RENDER_LOGIN_BAR',
    TOGGLE_GAME_POPUP: 'TOGGLE_GAME_POPUP',
    IS_OPEN_GAME_POPUP: 'IS_OPEN_GAME_POPUP',
    SET_MENU_TAB_SELECTED: 'SET_MENU_TAB_SELECTED',
    SET_DROPDOWN_MENU_OPTION_SELECTED: 'SET_DROPDOWN_MENU_OPTION_SELECTED',
    SET_FLAG_DEPOSIT_CASHMARKET_API: 'SET_FLAG_DEPOSIT_CASHMARKET_API',
};
